import React from 'react';
import PropTypes from 'prop-types';

import TextSmall from '../TextSmall';

import {
  StyledTitle,
  StyledCurrentJobWrapper,
  StyledExperience,
  StyledElement,
  StyledBox,
  StyledCompany,
  StyledParagraph,
  StyledJob,
  StyledBetweenDay,
  StyledDash,
  StyledButtonPlus,
  StyledPen,
  StyledTitleEditable,
  StyledActuallity,
  StyledTrash,
  StyledCrate,
  StyledBoxLine,
  StyledText,
  StyledEditable
} from './style';
import { StyledDay } from './day.style';

import { Pencil, Trash } from '../../../../assets/images/index';

const sortExperiences = experiences => {
  experiences.map(element => {
    if (element.endDate === '') {
      // eslint-disable-next-line no-param-reassign
      delete element.endDate;
    }
    return element;
  });

  const sortCurrentExperience = experiences.sort((a, b) => {
    if (b.endDate > a.endDate) {
      return 1;
    }
    if (a.endDate > b.endDate) {
      return -1;
    }
    return 0;
  });

  if (sortCurrentExperience) {
    if (
      sortCurrentExperience[sortCurrentExperience] &&
      sortCurrentExperience[sortCurrentExperience.length - 1].endDate === ''
    ) {
      sortCurrentExperience.splice(
        0,
        0,
        sortCurrentExperience.splice(sortCurrentExperience.length - 1, 1)[0]
      );
    }
  }

  return sortCurrentExperience;
};

const getCurrentExperiences = experiences => {
  const currentExperiences = experiences.filter(
    experience => experience.current
  );

  const sortCurrentExperiences = sortExperiences(currentExperiences);

  return sortCurrentExperiences;
};

const Experience = ({
  className,
  dataExperience,
  onEditMode,
  clickAddIcon,
  clickEditIcon,
  clickEditExperiencePastIcon,
  clickDeleteIcon
}) => {
  const sortCurrentExperiences = getCurrentExperiences(dataExperience);
  const sortDataExperience = sortExperiences(dataExperience);

  return (
    <div className={className}>
      <StyledTitle>
        Mi experiencia profesional
        {onEditMode && (
          <StyledButtonPlus dark size="xs" onClick={clickAddIcon} />
        )}
      </StyledTitle>
      {onEditMode && <div />}
      {onEditMode && sortCurrentExperiences.length > 0 && (
        <StyledCurrentJobWrapper>
          <StyledTitleEditable> (TRABAJO/S ACTUALES) </StyledTitleEditable>
          <StyledEditable
            size="m"
            color="grayDark"
            svg={Pencil}
            onClick={clickEditIcon}
            hover
          />
        </StyledCurrentJobWrapper>
      )}
      {sortDataExperience.length !== 0 ? (
        <StyledExperience>
          {sortDataExperience.map(item => (
            <StyledElement
              key={item.title + item.startDate}
              actual={item.current}
              editable={onEditMode}
            >
              <StyledBox>
                {item.current ? (
                  <StyledActuallity> Actual </StyledActuallity>
                ) : (
                  <StyledDay date={item.endDate} />
                )}
              </StyledBox>
              <StyledCrate>
                <StyledBoxLine>
                  <StyledCompany> {item.companyName} </StyledCompany>
                  <StyledText> ( </StyledText>
                  <StyledBetweenDay format="MM/YYYY">
                    {item.startDate}
                  </StyledBetweenDay>
                  <StyledDash> - </StyledDash>
                  {item.current ? (
                    <StyledText> actualidad </StyledText>
                  ) : (
                    <StyledBetweenDay format="MM/YYYY">
                      {item.endDate}
                    </StyledBetweenDay>
                  )}
                  <StyledText> ) </StyledText>
                  {onEditMode && item.endDate && (
                    <div>
                      <StyledPen
                        size="m"
                        color="grayDark"
                        svg={Pencil}
                        onClick={() => clickEditExperiencePastIcon(item)}
                        hover
                      />
                      <StyledTrash
                        size="m"
                        color="grayDark"
                        svg={Trash}
                        onClick={() => clickDeleteIcon(item)}
                        hover
                      />
                    </div>
                  )}
                </StyledBoxLine>
                <StyledJob> {item.title} </StyledJob>
                <StyledParagraph> {item.summary} </StyledParagraph>
              </StyledCrate>
            </StyledElement>
          ))}
        </StyledExperience>
      ) : (
        <TextSmall>
          Parece que aún no hay experiencia profesional para mostrar.
        </TextSmall>
      )}
    </div>
  );
};
Experience.propTypes = {
  className: PropTypes.string,
  onEditMode: PropTypes.bool,
  dataExperience: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      companyName: PropTypes.string,
      title: PropTypes.string,
      summary: PropTypes.string,
      startDate: PropTypes.string,
      endDate: PropTypes.string,
      current: PropTypes.bool
    })
  ),
  clickAddIcon: PropTypes.func,
  clickEditIcon: PropTypes.func,
  clickEditExperiencePastIcon: PropTypes.func,
  clickDeleteIcon: PropTypes.func
};

Experience.defaultProps = {
  dataExperience: [],
  onEditMode: false
};

export default Experience;
